import styled from 'styled-components';

import { CuiTheme } from '@crehana/ui';

export const containerHeight = '500px';

export const containerWidthMd = '920px';
export const containerWidthLg = '1100px';

export const textContainerWidthMd = '380px';
export const textContainerWidthLg = '400px';

export const StyledImage = styled.div`
  height: 480px;
  width: 420px;
  transform: translateX(60px);
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    height: 580px;
    width: 540px;
    transform: translateX(100px);
  }
`;

export const StyledContainer = styled.div`
  max-width: ${containerWidthMd};
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    max-width: ${containerWidthLg};
  }
`;

export const StyledCardContainer = styled.div`
  max-height: ${containerHeight};
  max-width: ${containerWidthMd};

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    max-width: ${containerWidthLg};
  }
`;

export const StyledLeftBar = styled.div<{
  accentColor: string;
  cardInView: number;
}>`
  // this color belongs to new ui system
  background-color: #d9d9d9;
  border-radius: 4px;
  height: 400px;

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    height: 460px;
  }

  ::after {
    content: '';
    width: 100%;
    height: 25%;
    position: absolute;
    transition: 0.75s;
    top: ${({ cardInView }) => cardInView * 25}%;
    background-color: ${({ accentColor }) => accentColor};
  }
`;

export const StyledTextContainer = styled.div`
  width: ${textContainerWidthMd};

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    width: ${textContainerWidthLg};
    height: 400px;
  }
`;
